import { useQuery } from 'react-query';
import { TransactionAPI } from 'api/admin/transaction';
import { TRANSACTIONS } from 'helpers/constants';

export default function useTransactions({ userId, tournamentId }) {
  return useQuery([TRANSACTIONS, userId, tournamentId], () =>
    TransactionAPI.getAll(userId, tournamentId)
  );
}
